export const signIn = () => {
  return {
    title: 'Sign In',
    subtitle_1: 'Please sign in with your company email',
    sign_in_google: 'Sign in with Google',
    sign_in_microsoft: 'Sign in with Microsoft',
    email_address: 'Enter username or email address',
    password: 'Enter password',
    remember_me: 'Remember me',
    forgot_password: 'Forgot password?',
    request_access: 'Request Access',
    sign_in: 'Sign In',
    management_portal: 'Management Portal',
    main_message: 'Build connections and custom field forms faster than ever before!',
    contact_us: 'Contact us',
    messages: {
      wrong_user_password: 'The credentials entered are not valid.  Please try again.',
      terms_and_conditions: 'Using the MyWork Platform, you agree to the ',
      terms_and_conditions_link: 'terms and conditions.',
      privacy_policy: 'Privacy Policy',
      my_work_all_rights_reserved: 'MyWork, LLC All Rights Reserved'
    },
    masquerade: {
      title: 'Masquerade',
      mask_as: 'Masquerading as',
      subtitle: 'Select a client for masquerading to help troubleshoot issues, view work orders and manage users.',
      skip: 'Skip',
      go: 'Go',
      start: 'Start',
      search_client: 'Search Client Name',
      search_client_mobile: 'Search Client',
      frequently: 'Frequently used',
      no_frequently: 'There are no frequently used clients.',
      no_client: 'No Client Selected',
      switch: 'Switch Client',
      back: 'Back'
    },
    logout: {
      title: 'Your Session Ended',
      message:
        'We’re sorry but something has happened to your session. Sign in again, to ensure all your work is up to date.'
    },
    invalid_user: {
      title: 'Invalid Credentials',
      message: 'The credentials entered are not valid. Please try again.'
    }
  }
}
